function onVimeoReady() {
    const videos = document.querySelectorAll('.image.text-box-extended__video');

    videos.forEach(function (video) {
        const iframe = video.querySelector('iframe');
        const iframePlaceholder = video.querySelector('.text-box-extended__video-placeholder');

        if (iframe) {
            const player = new Vimeo.Player(iframe);

            if (iframePlaceholder) {
                player.on('play', function () {
                    iframePlaceholder.style.display = 'none';
                });
            }
        }
    });
}

if (window.Vimeo) {
    onVimeoReady();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        const script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        script.onload = onVimeoReady;
        document.head.appendChild(script);
    });
}
